import React from "react";
import "../../styles/dayStyles/Day04.css";

export default function Day04() {
    return (
        // red box container
        <div className="day-container container-color4">

            {/* circle animations */}
            <div className="outer-circle">
                <div className="middle-circle">
                    <div className="inner-circle" />
                </div>
            </div>
        </div>
    )
}
